import { Box, Icon, Typography } from '@mui/material'

const EditOverlay = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        bgcolor: '#47474778',
        borderRadius: '4.5px',
        color: 'white.main',
        cursor: 'pointer',
        zIndex: 100,
      }}
    >
      <Icon>edit</Icon>
      <Typography>Click to edit section</Typography>
    </Box>
  )
}

export default EditOverlay
